<template>
  <div class="container-content">
    <div class="home-container">
      <!--轮播图-->
      <div class="swiper-container" id="swiper1">
        <div class="swiper-wrapper">
          <div class="swiper-slide" style="background: no-repeat url(/static/images/banner/banner1.png);background-position: center;background-size: cover;">
            <div class="body-content">
              <div class="main-panel">
                <div class="left-part">
                  <h3>“十三五”国家重点研发计划<br>NQI重点专项</h3>
                  <p>始终面向国家需求 始终站在科学前沿 始终坚持综合研究</p>
                  <div class="data-count">
                    <ul>
                      <li>
                        <span class="value"><i class="bigger">{{countProject}}</i>个</span>
                        <span class="name">重大项目</span>
                      </li>
                      <li>
                        <span class="value"><i class="bigger">{{countResult}}</i>项</span>
                        <span class="name">核心成果</span>
                      </li>
                      <li>
                        <span class="value"><i class="bigger">{{countDept}}</i>家</span>
                        <span class="name">参与单位</span>
                      </li>
                      <li>
                        <span class="value"><i class="bigger">{{countPerson}}</i>名</span>
                        <span class="name">参与人次</span>
                      </li>
                    </ul>
                  </div>
                  <div class="button-panel">
                    <a href="/dataAssemble">数说NQI</a>
                    <a href="/achievements">成果荟萃</a>
                    <a href="/project">项目风采</a>
                  </div>
                </div>
                <div class="right-part">
                  <video height="230" width="425" autoplay="autoplay" muted controls>
                    <source :src="fileUrl + 'video/banner.mp4'" type="video/mp4">
                    您的浏览器不支持 HTML5 video 标签。
                  </video>
                </div>
              </div>
            </div>
          </div>
          <div class="swiper-slide" style="background: no-repeat url(/static/images/banner/banner2.png);background-position: center;background-size: cover;">
            <div class="body-content">
              <div class="main-panel">
                <div class="left-part">
                  <h3>“十三五”国家重点研发计划<br>NQI重点专项</h3>
                  <p>始终面向国家需求 始终站在科学前沿 始终坚持综合研究</p>
                  <div class="data-count">
                    <ul>
                      <li>
                        <span class="value"><i class="bigger">{{countProject}}</i>个</span>
                        <span class="name">重大项目</span>
                      </li>
                      <li>
                        <span class="value"><i class="bigger">{{countResult}}</i>项</span>
                        <span class="name">核心成果</span>
                      </li>
                      <li>
                        <span class="value"><i class="bigger">{{countDept}}</i>家</span>
                        <span class="name">参与单位</span>
                      </li>
                      <li>
                        <span class="value"><i class="bigger">{{countPerson}}</i>名</span>
                        <span class="name">参与人次</span>
                      </li>
                    </ul>
                  </div>
                  <div class="button-panel">
                    <a href="/dataAssemble">数说NQI</a>
                    <a href="/achievements">成果荟萃</a>
                    <a href="/project">项目风采</a>
                  </div>
                </div>
                <div class="right-part">
                  <video height="230" width="425" controls>
                    <source :src="fileUrl + 'video/banner.mp4'" type="video/mp4">
                    您的浏览器不支持 HTML5 video 标签。
                  </video>
                </div>
              </div>
            </div>
          </div>
          <div class="swiper-slide" style="background: no-repeat url(/static/images/banner/banner3.png);background-position: center;background-size: cover;">
            <div class="body-content">
              <div class="main-panel">
                <div class="left-part">
                  <h3>“十三五”国家重点研发计划<br>NQI重点专项</h3>
                  <p>始终面向国家需求 始终站在科学前沿 始终坚持综合研究</p>
                  <div class="data-count">
                    <ul>
                      <li>
                        <span class="value"><i class="bigger">{{countProject}}</i>个</span>
                        <span class="name">重大项目</span>
                      </li>
                      <li>
                        <span class="value"><i class="bigger">{{countResult}}</i>项</span>
                        <span class="name">核心成果</span>
                      </li>
                      <li>
                        <span class="value"><i class="bigger">{{countDept}}</i>家</span>
                        <span class="name">参与单位</span>
                      </li>
                      <li>
                        <span class="value"><i class="bigger">{{countPerson}}</i>名</span>
                        <span class="name">参与人次</span>
                      </li>
                    </ul>
                  </div>
                  <div class="button-panel">
                    <a href="/dataAssemble">数说NQI</a>
                    <a href="/achievements">成果荟萃</a>
                    <a href="/project">项目风采</a>
                  </div>
                </div>
                <div class="right-part">
                  <video height="230" width="425" controls>
                    <source :src="fileUrl + 'video/banner.mp4'" type="video/mp4">
                    您的浏览器不支持 HTML5 video 标签。
                  </video>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Add Pagination -->
        <div class="swiper-pagination swiper-pagination-white"></div>
      </div>
    </div>

    <!-- 聚焦十三五 -->
    <div class="shisanwu-container">
      <div class="body-content shisanwu">
        <div class="shisanwu-body">
          <div class="body-left">
            <div class="swiper-container" id="swiperVideo">
              <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(fruit,index) in swiperImgs" :key="index">
                  <div class="swiper-inner">
                    <img v-if="index===0||index===4||index===5||index===6" :src="'../../../static/images/' + (index+1) + '.png'" alt="">
                    <img v-if="index==1||index===2||index===3" :src="'../../../static/images/' + (index+1) + '.jpg'" alt="">
                    <span>{{fruit.name}}</span>
                  </div>
                </div>
              </div>
              <!-- Add Pagination -->
              <div class="swiper-pagination swiper-pagination-white" style="text-align: right;"></div>
            </div>
          </div>
          <div class="body-right">
            <label class="body-right-title">一站式查询</label>
            <div class="body-right-list">
              <ul>
                <li>
                  <i class="li-icon" style="background-color: #FF8A56;">
                    <img src="../../assets/images/icon/icon-kj.png"/>
                  </i>
                  <a class="li-span" href="/websiteSearch">参与单位查询</a>
                </li>
                <li>
                  <i class="li-icon" style="background-color: #66B5FF;">
                    <img src="../../assets/images/icon/icon-kj2.png"/>
                  </i>
                  <a class="li-span" href="http://jjg.spc.org.cn/resmea/view/index" target="_blank">计量技术规范查询</a>
                </li>
                <li>

                  <i class="li-icon" style="background-color: #2E5C9A;">
                    <img src="../../assets/images/icon/icon-jl2.png"/>
                  </i>
                  <a class="li-span" href="https://www.ncrm.org.cn/" target="_blank">国家标准物质查询</a>
                </li>
                <li>
                  <i class="li-icon" style="background-color: #136BAE;">
                    <img src="../../assets/images/icon/icon-kj3.png"/>
                  </i>
                  <a class="li-span" href="https://www.nmdc.ac.cn" target="_blank">国家计量科学数据中心</a>
                </li>
                <li>
                  <i class="li-icon" style="background-color: #778CD4;">
                    <img src="../../assets/images/icon/icon-gt.png"/>
                  </i>
                  <a class="li-span" href="http://psp.e-cqs.cn/aeaCma/cma/apply/onlineApply/importDataQuery.jsp" target="_blank">检定校准机构能力查询</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 功能区入口 -->
    <div class="body-container middle-image-container">
      <div class="body-content">
        <div class="content-function">
          <div class="content-function">
            <div class="carousel-show">
              <div class="carousel-overall">
                <div class="outcome-header">
                  <div class="title">亮点成果</div>
                  <div class="sub-title">Highlight achievements</div>
                  <div class="line"></div>
                </div>
                <div class="card">
                  <div class="left">
                    <a href="/bright?tab=计量">
                      <img src="../../assets/images/hot-back/jl.png" alt="">
                    </a>
                    <div>计量</div>
                    <div>Metering</div>
                  </div>
                  <div class="right">
                    <div class="r-left">
                      <div class="top">
                        <a href="/bright?tab=标准">
                          <img src="../../assets/images/hot-back/bz.png" alt="">
                        </a>
                        <div>标准</div>
                        <div>Standard</div>
                      </div>
                      <div class="top" style="margin-top: 40px;">
                        <a href="/bright?tab=检验检测">
                          <img src="../../assets/images/hot-back/jyjc.png" alt="">
                        </a>
                        <div>检验检测</div>
                        <div>Examine</div>
                      </div>
                    </div>
                    <div class="r-right">
                      <div class="top">
                        <a href="/bright?tab=认证认可">
                          <img src="../../assets/images/hot-back/rzrk.png" alt="">
                        </a>
                        <div>认证认可</div>
                        <div>Certification</div>
                      </div>
                      <div class="top" style="margin-top: 40px;">
                        <a href="/bright?tab=典型示范">
                          <img src="../../assets/images/hot-back/dxsf.png" alt="">
                        </a>
                        <div>典型示范</div>
                        <div>Typical demonstratio</div>
                      </div>
                    </div>
                  </div>

                  <!--                  <div class="function-box column" style="width: 220px;">
                                      <a href="/bright?tab=计量"><p class="img"><img src="../../assets/images/hot-back/jl.png" width="100%">
                                      <label>计量</label>
                                      </p>
                                      </a>
                                    </div>
                                    <div class="function-box column" style="width: 220px;">
                                      <a href="/bright?tab=标准"><p class="img"><img src="../../assets/images/hot-back/bz.png" width="100%">
                                      <label>标准</label>
                                      </p>
                                      </a>
                                    </div>
                                    <div class="function-box column" style="width: 220px;">
                                      <a href="/bright?tab=检验检测"><p class="img"><img src="../../assets/images/hot-back/jyjc.png" width="100%">
                                      <label>检验检测</label>
                                      </p>
                                      </a>
                                    </div>
                                    <div class="function-box column" style="width: 220px;">
                                      <a href="/bright?tab=认证认可"><p class="img"><img src="../../assets/images/hot-back/rzrk.png" width="100%">
                                      <label>认证认可</label>
                                      </p>
                                      </a>
                                    </div>
                                    <div class="function-box column" style="width: 220px;">
                                      <a href="/bright?tab=典型示范"><p class="img"><img src="../../assets/images/hot-back/dxsf.png" width="100%">
                                      <label>典型示范</label>
                                      </p>
                                      </a>
                                    </div>-->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 什么是NQI -->
    <div class="body-container" style="margin-top: 16px;">
      <div class="body-content">
        <div class="content-function">
          <div class="carousel-show" style="margin-top: 60px;">
            <div class="title">NQI简介</div>
            <div class="content">
              2005年，联合国贸发组织（UNCTAD）和世界贸易组织（WTO）共同提出NQI的理念。2006年，联合国工业发展组织（UNIDO）和国际标准化组织（ISO）在总结质量领域一百多年实践经验基础上，正式提出计量、标准、合格评定（包括检验检测、认证认可）共同构成NQI。
            </div>
            <div class="carousel-overall">
              <div class="function-icon">
                <div class="function-box column" style="width: 400px;">
                  <p class="small"><a @click="pushNewsDetail(1)"><b>阅读更多</b></a></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 通知公告 -->
    <div class="notice-container">
      <div class="body-content notice">
        <div class="notice-left">
          <div class="img-cont">
            <img src="../../assets/images/home/通知公告@2x.png" alt="">
            <div class="text">
              <span>通知</span>
              <span>公告</span>
            </div>
          </div>
        </div>
        <div class="notice-list">
          <ul>
            <li v-for="notice in noticeList" :key="notice.id">
              <a :href="'/newsDetail?id=' + notice.id"><span>{{notice.title}}</span></a>
              <span>{{notice.publishTime}}</span>
            </li>
            <li v-for="notice in noticeList" :key="'notice'+notice.id">
              <a :href="'/newsDetail?id=' + notice.id"><span>{{notice.title}}</span></a>
              <span>{{notice.publishTime}}</span>
            </li>
          </ul>
        </div>
        <div class="notice-right" @click="more">
          <span style="cursor: pointer;">更多公告</span>
        </div>
      </div>
    </div>

    <!-- 行业要闻 -->
    <div v-if="false" class="important-news-container body-container">
      <div class="body-content important-news">
        <div class="left-content-function">
          <div class="content-function">
            <div class="function-text">
              <div class="texts-left">行业要闻</div>
              <span class="texts-right" @click="navToPath('/industyNews')">
                更多<i class="el-icon-arrow-right"></i>
              </span>
            </div>
            <div class="carousel-show">
              <div class="carousel-overall column">
                <div class="tab-nav">
                  <ul>
                    <li :class="news1==='标准样品'?'active':''" @mouseenter="changeNews(1, '标准样品')">标准样品</li>
                    <li :class="news1==='计量基标准'?'active':''" @mouseenter="changeNews(1, '计量基标准')">计量基标准</li>
                    <li :class="news1==='国内标准'?'active':''" @mouseenter="changeNews(1, '国内标准')">国内标准</li>
                    <li :class="news1==='软件系统'?'active':''" @mouseenter="changeNews(1, '软件系统')">软件系统</li>
                    <li :class="news1==='研究报告'?'active':''" @mouseenter="changeNews(1, '研究报告')">研究报告</li>
                  </ul>
                </div>
                <div class="tab-content">
                  <ul>
                    <li>
                      石墨烯特性参数测量标准装置
                      <span class="right-time">12-23</span>
                    </li>
                    <li>
                      高性能电工钢材料动态磁性计量标准装置
                      <span class="right-time">11-23</span>
                    </li>
                    <li>
                      永磁材料磁参数现场计量标准装置
                      <span class="right-time">11-23</span>
                    </li>
                    <li>
                      微纳薄膜材料结构光散射测量标准装置
                      <span class="right-time">11-23</span>
                    </li>
                    <li>
                      微纳薄膜材料结构光散射测量标准装置
                      <span class="right-time">10-23</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="right-content-function">
          <div class="content-function">
            <div class="function-text">
              <div class="texts-left">互动</div>
            </div>
            <div class="carousel-show">
              <div class="carousel-overall column">
                <div class="tab-nav">
                  <ul>
                    <li :class="news3==='留言咨询'?'active':''" @mouseenter="changeNews(3, '留言咨询')">留言咨询</li>
                    <li :class="news3==='征集调查'?'active':''" @mouseenter="changeNews(3, '征集调查')">征集调查</li>
                  </ul>
                </div>
                <div class="tab-content">
                  <ul>
                    <li>
                      国家市场监督管理总局关于《市场监管领域重…
                    </li>
                    <li>
                      市场监管总局关于就《市场监管总局关于贯彻…
                    </li>
                    <li>
                      质量保证体系
                    </li>
                    <li>
                      微纳薄膜材料结构光散射测量标准装置
                    </li>
                    <li>
                      微纳薄膜材料结构光散射测量标准装置
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 质量强国在众多重要领域发挥关键作用 -->
    <div class="body-container hot-service">
      <div class="body-content">
        <p class="floor-title">质量强国在众多重要领域发挥关键作用</p>
        <div class="main-line"></div>
        <p class="floor-sub-title">国家强，则质量必须强。经济社会又好又快发展，必须好字当头，质量第一。</p>
        <div class="hot-service-list">
          <div class="hot-service-item" v-for="(category,index) in impProjectList" :class="hotService==index?'is-active':''" @mouseenter="hotService=index" :key="index">
            <div class="hot-service-title">
              <img class="service-icon normal-icon" :src="'../../../static/images/public/icon/'+index+'.png'" alt="">
              <img class="service-icon active-icon" :src="'../../../static/images/public/icon/'+index+'-active.png'" alt="">
              <div class="title-text">{{ category.name }}</div>
              <img class="active-down-icon" src="../../assets/images/public/active.png" alt="">
            </div>
            <div class="hot-service-content" :style="'background: url(../../../static/images/public/'+index+'.png) no-repeat 50% 50% #F8F8F8;'">
              <div class="hot-service-top">
                <span>{{ category.name }}热门项目</span>
                <a href="" v-if="false">查看全部服务</a>
              </div>
              <div class="sub-list-content">
                <ul class="sub-list">
                  <li v-for="project in category.list" :key="project.id"><a :href="'/projectDetail?id=' + project.id">{{ project.name }}({{project.number}})</a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 成果概览 -->
    <div class="research-highlight-container body-container" style="background-color: #fff;">
      <div class="body-content research-highlight">
        <div class="left-content-function">
          <div class="content-function">
            <div class="function-text">
              <div class="texts-left">{{lawInfo.firstThemeName}}</div>
              <span class="texts-right" @click="zcfgMore">
                更多<i class="el-icon-arrow-right"></i>
              </span>
            </div>
            <div class="carousel-show">
              <div class="carousel-overall column" v-if="lawInfo.secondThemeVOList">
                <div class="tab-nav" v-if="false">
                  <ul>
                    <li v-for="(item,index) in lawInfo.secondThemeVOList"
                        :key="item.id"
                        :class="news3===index?'active':''" @click="news3=index">{{item.secondThemeName}}</li>
                  </ul>
                </div>
                <div class="tab-content">
                  <ul>
                    <li v-for="i in lawInfo.secondThemeVOList[0].noticeList" :key="i.id">
                      <a :href="'/newsDetail?id=' + i.id">{{i.title}}</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="left-content-function" v-if="false">
          <div class="content-function">
            <div class="function-text">
              <div class="texts-left">{{techNotice.firstThemeName || '行业要闻'}}</div>
              <span class="texts-right">
                更多<i class="el-icon-arrow-right"></i>
              </span>
            </div>
            <div class="carousel-show">
              <div class="carousel-overall column" v-if="techNotice.secondThemeVOList">
                <div class="tab-nav">
                  <ul>
                    <li v-for="(item, index) in techNotice.secondThemeVOList"
                        :key="'news4'+index"
                        :class="news4===index?'active':''"
                        @click="news4=index">{{item.secondThemeName}}</li>
                  </ul>
                </div>
                <div class="tab-content" style="height: 301px;">
                  <ul v-for="(item, index) in techNotice.secondThemeVOList"
                      :key="'news4Content' + index"
                      v-show="news4===index">
                    <li v-for="i in item.noticeList" :key="i.id" @click="pushNewsDetail(i.id)" style="height: 62px;">
                      {{i.title}}
                      <span class="right-time">{{i.publishTime}}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="right-content-function">
          <div class="content-function">
            <div class="function-text">
              <div class="texts-left">相关机构</div>
            </div>
            <div class="organization-list">
              <div class="item"><a href="https://www.nim.ac.cn/" target="_blank">中国计量科学研究院</a></div>
              <div class="item"><a href="https://www.cnis.ac.cn/pcindex/" target="_blank">中国标准化研究院</a></div>
              <div class="item"><a href="http://www.caiq.org.cn/" target="_blank">中国检验检疫科学研究院</a></div>
              <div class="item"><a href="https://www.csei.org.cn/" target="_blank">中国特种设备检测研究院</a></div>
              <div class="item"><a href="https://www.cnas.org.cn/" target="_blank">中国合格评定国家认可中心</a></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 专题专栏 -->
    <div class="special-container" v-if="false">
      <div class="body-content special">
        <div class="special-header">
          <span>专题专栏</span>
        </div>
        <div class="special-body">
          <ul>
            <li>
              <img src="../../assets/images/home/ssw@2x.png" alt="">
            </li>
            <li>
              <img src="../../assets/images/home/zd@2x.png" alt="">
            </li>
            <li>
              <img src="../../assets/images/home/yz@2x.png" alt="">
            </li>
          </ul>
          <ul>
            <li>
              <img src="../../assets/images/home/5@2x.png" alt="">
            </li>
            <li>
              <img src="../../assets/images/home/3@2x.png" alt="">
            </li>
            <li>
              <img src="../../assets/images/home/6@2x.png" alt="">
            </li>
          </ul>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import img1 from '../../assets/images/hot-back/1.png';
import img2 from '../../assets/images/hot-back/2.png';
import img3 from '../../assets/images/hot-back/3.png';
import img4 from '../../assets/images/hot-back/4.png';
import filterList from '@/components/filterList';
import searchList from '@/components/searchList';
export default {
  name: 'home',
  components: {
    searchList,
    filterList
  },
  data () {
    return {
      hotService: 0,
      fileUrl: '',
      currentVideoUrl: '20210707/1.mp4',
      videoPlayFlag: false,
      show: '',
      normalListData: [],
      one: false,
      active: '',
      standardType: '什么是NQI',
      news1: '标准样品',
      news2: '总局文件',
      news3: '留言咨询',
      news4: 0,
      meListData: [],
      news1Data: [],
      news2Data: [],
      news3Data: [],
      picture: [
        {
          url: img1,
          name: '计量',
          record: '3000条记录'
        },
        {
          url: img2,
          name: '标准',
          record: '1000条记录'
        },
        {
          url: img3,
          name: '认证认可',
          record: '2000条记录'
        },
        {
          url: img4,
          name: '检验检测',
          record: '100条记录'
        }
      ],
      listData: [
        {
          id: '1',
          name: '计量'
        },
        {
          id: '2',
          name: '标准'
        },
        {
          id: '3',
          name: '认证认可'
        },
        {
          id: '4',
          name: '检验检测'
        }
      ],
      noticeList: [],
      noticeScrollIndex: 0,
      nqiInfo: {},
      lawInfo: {},
      impFruitList: [],
      scrollIndex: 0,
      techNotice: {},
      impProjectList: [],
      countProject: 0,
      countResult: 0,
      countDept: 0,
      countPerson: 0,
      swiperImgs: [{
        name: '全球玻尔兹曼常数测定结果'
      }, {
        name: '圆柱声学法核心部件-精密声学谐振腔'
      }, {
        name: '锶原子光晶格钟实验系统'
      }, {
        name: '锶原子光晶格钟核心部件——磁光阱'
      }, {
        name: '北斗时间远程传递装置'
      }]
    }
  },
  created () {
    this.fileUrl = global.FileUrl;
  },
  watch: {
    scrollIndex: function (val) {
      const _self = this;
      if (val < 0) _self.scrollIndex = 0;
      if (val > _self.impFruitList.length - 4) _self.scrollIndex = _self.impFruitList.length - 4;
      $('.outcome-body-scroll ul').css('margin-left', -296 * _self.scrollIndex + 'px');
    }
  },
  mounted () {
    $('.animate').scrolla();
    // this.fetchList();
    // this.fetchMetroloyList()
    // this.getNewsList()
    Swiper('#swiperVideo', {
      loop: true,
      pagination: '.swiper-pagination',
      paginationClickable: true,
      autoplay: 15000,
      spaceBetween: 30
    });

    // 初始化提示信息
    $('[data-toggle="popover"]').popover();
    this.fetchImpFruit();
    this.fetchMainMessage();
    // setTimeout(() => {
    //   this.getCgglTitle();
    // }, 1000)
    this.fetchData();
    // this.getCgglTitle();
  },
  methods: {
    fetchData () {
      this.post('/dataapi/open/nqi/fruit/countProject').then(res => {
        this.countProject = res.result;
      });
      this.post('/dataapi/open/nqi/fruit/countImportFruit').then(res => {
        this.countResult = res.result;
      });
      this.post('/dataapi/open/nqi/fruit/countProjectUnit').then(res => {
        this.countDept = res.result;
      });
      this.fetch('/dataapi/open/nqi/notice/getLawList').then(res => {
        this.lawInfo = res.result;
      });
      this.post('/dataapi/open/nqi/fruit/countPeopleSum').then((res) => {
        this.countPerson = res.result;
        setTimeout(() => {
          Swiper('#swiper1', {
            loop: true,
            pagination: '.swiper-pagination',
            paginationClickable: true,
            autoplay: 15000,
            spaceBetween: 30
          });
        }, 150);
      });
    },
    fetchMainMessage () {
      this.fetch('/dataapi/open/nqi/notice/getNoticeInfo').then(res => {
        this.noticeList = res.result.noticeList;
        const _self = this;
        this.$nextTick(function () {
          setInterval(function () {
            _self.noticeScrollIndex++;
            $('.notice-list').find('ul').css('margin-top', (-42 * _self.noticeScrollIndex) + 'px');
            if (_self.noticeScrollIndex >= 6) {
              _self.noticeScrollIndex = 0;
            }
          }, 5000);
        })
      });
      this.fetch('/dataapi/open/nqi/notice/getNqiInfo').then(res => {
        this.nqiInfo = res.result;
      });
      this.fetch('/dataapi/open/nqi/notice/getImportNewsInfo').then(res => {
        this.techNotice = res.result;
      });
      this.fetch('/dataapi/open/nqi/project/getDomainProjectList').then(res => {
        let result = res.result;
        let impProjectList = [];
        for (let key of Object.keys(result)) {
          impProjectList.push({
            name: key,
            list: result[key]
          })
        }
        this.impProjectList = impProjectList;
      });
    },
    addActive (e) {
      if ($(e.target).hasClass('is-active')) return;
      $('.is-active').removeClass('is-active');
      $(e.target).addClass('is-active');
    },
    // 跳转链接
    navToPath (path) {
      this.$router.push({ path });
    },
    goCommonsList () {
      this.$router.push({ path: '/analysisData' });
    },
    findMore () {
      localStorage.setItem('filterValue', '标准')
      this.commonCommit()
      this.$router.push({ path: '/commonList' })
    },
    openNews (url) {
      setTimeout(() => {
        window.open(url)
      }, 1)
    },
    commonCommit () {
      this.$store.commit('saveNormalList', [])
      this.$store.commit('saveFilterValue')
      this.$store.commit('saveIsHot', false)
      this.$store.commit('saveIsTopNav', false)
    },
    pushNewsDetail (id) {
      this.$router.push({path: '/newsDetail?id=' + id})
    },
    getNewsList () {
      this.fetch('/dataapi/open/nqi/notice/showList').then(res => {
        this.news1Data = res.resultfilter(item => { return item.firstThemeName === '要闻'; })[0].value;
        this.news2Data = res.resultfilter(item => { return item.firstThemeName === '政务'; })[0].value;
        this.news3Data = res.resultfilter(item => { return item.firstThemeName === '互动'; })[0].value;
      });
    },
    fetchList () {
      this.post(
        '/cer/cnas/hotData/4').then(res => {
        this.picture = res.result
        this.picture[0].url = img1
        this.picture[1].url = img2
        this.picture[2].url = img3
        this.picture[3].url = img4
      })
    },
    area: function () {
      this.show = 1;
    },
    state: function () {
      this.sum = 1;
    },
    selected (name) {
      this.active = name;
    },
    goCommonList (name) {
      this.$store.commit('saveNormalListDataPage',
        {currPage: 1, pageSize: 10}
      )
      this.$store.commit('saveHotListData', [])
      localStorage.setItem('filterValue', name)
      this.$store.commit('saveFilterValue')
      this.pushRouter()
    },
    pushRouter () {
      this.$store.commit('saveIsHot', true)
      this.$router.push({ path: '/commonList' })
    },
    changeStandardType (type) {
      if (this.standardType === type) return;
      this.standardType = type;
      // this.fetchMetroloyList()
    },
    changeNews (type, value) {
      const _self = this;
      if (_self['news' + type] === value) return;
      _self['news' + type] = value;
    },
    toArticle () {
      this.$router.push({ path: '/article', query: { type: 2 } })
    },
    fetchImpFruit () {
      this.post('/dataapi/open/nqi/fruit/listImportFruit').then(res => {
        this.impFruitList = res.result;
        $('.outcome-body-scroll').find('ul').width(296 * this.impFruitList.length);
      });
    },
    more () {
      this.$router.push({path: '/notice', query: {secondId: 2, name: '通知公告'}});
    },
    zcfgMore () {
      this.$router.push({path: '/notice', query: {id: 6}});
    }
  }
};
</script>

<style lang="less" scoped>
.container-content {
  width: 100%;
  a {
    color: inherit;
    &:hover {
      text-decoration: none;
    }
  }
  .home-container {
    position: relative;
    width: 100%;
    height: 460px;
    margin: 0 auto;
    display: flex;

    .swiper-container {
      flex: 1;
      .main-panel {
        margin: 60px 40px;
        display: flex;
        justify-content: space-between;
        .left-part {
          display: flex;
          flex-flow: column;
        }
        .right-part {
          padding-top: 40px;
        }
        h3 {
          color: #FFFFFF;
          font-size: 48px;
          font-weight: bold;
        }
        p {
          font-size: 20px;
          color: #FFFFFF;
          margin: 24px 0 0;
        }
        .data-count {
          height: 60px;
          margin: 40px 0
        }
        li {
          float: left;
          height: 36px;
          width: 116px;
          border-left: 1px solid #FFFFFF;
          color: #FFFFFF;
          &:last-child {
            border-right: 1px solid #FFFFFF;
          }
          span {
            font-size: 18px;
            color: #FFFFFF;
            display: block;
            text-align: center;
          }
          .value {
            margin-bottom: 6px;
            margin-top: -18px;
            .bigger {
              font-size: 28px;
              font-style: normal;
            }
          }
        }
        .button-panel {
          a {
            background: #FEA500;
            color: #FFFFFF;
            font-size: 16px;
            margin-right: 24px;
            padding: 12px 28px;
          }
        }
      }
    }
  }

  .swiper-inner {
    position: relative;
    height: 426px;
    img {
      width: 100%;
      max-height: 100%;
    }
    span {
      position: absolute;
      left: 0;
      bottom: 0;
      z-index: 1;
      width: 100%;
      height: 40px;
      line-height: 40px;
      text-align: center;
      font-size: 16px;
      color: #fff;
      background-color: #DC2D29;
    }
  }

  .body-content {
    width: @body-width;
    margin: 0 auto;
  }

  .notice-container {
    width: 100%;
    padding: 60px 0 60px 0;
    background-color: #fff;
    .notice {
      display: flex;
      height: 100px;
      background: #F7F8FB;
      .notice-left {
        flex: 0 0 117px;
        .img-cont {
          position: relative;
          width: 107px;
          padding: 8px 0 8px 10px;
          box-sizing: border-box;
          img {
            width: 100%;
          }
          .text {
            position: absolute;
            top: 12px;
            left: 22px;
            z-index: 1;
            span {
              display: block;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: bold;
              color: #FEA500;
              font-size: 22px;
              letter-spacing: 14px;
              text-shadow: 1px 1px 2px #FFFFFF;
              line-height: 34px;
            }
          }
        }
      }
      .notice-list {
        flex: 1;
        padding-left: 24px;
        padding-right: 48px;
        box-sizing: border-box;
        overflow: hidden;
        ul {
        }
        li {
          display: flex;
          justify-content: space-between;
          margin: 20px 0;
          span {
            position: relative;
            padding-left: 12px;
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.85);
            line-height: 22px;
            &:first-child:before {
              content: '';
              position: absolute;
              top: 50%;
              left: 0;
              transform: translateY(-50%);
              width: 5px;
              height: 5px;
              background-color: #000000;
              border-radius: 50%;
            }
            &:last-child {
              color: rgba(0, 0, 0, 0.45);
            }
          }
        }
      }
      .notice-right {
        flex: 0 0 108px;
        display: flex;
        align-items: center;
        padding-right: 40px;
        span {
          width: 68px;
          height: 30px;
          text-align: center;
          line-height: 30px;
          background: rgba(254,165,0,0.15);
          border-radius: 15px;
          font-size: 12px;
          font-weight: 400;
          color: #fea500;
        }
      }
    }
  }

  .shisanwu-container {
    width: 100%;
    padding: 30px 0 30px 0;
    background-color: rgba(246, 247, 251, 1);
    .shisanwu {
      .shisanwu-header {
        display: flex;
        justify-content: space-between;
        padding: 0 0 20px 0;
        span {
          &:first-child {
            border-bottom: 2px solid rgba(46, 92, 154, 1);
            font-family: PingFangSC-Medium, PingFang SC;
            font-size: 24px;
            font-weight: bold;
            color: #000;
            line-height: 33px;
          }
          &:last-child {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #8F8F8F;
            line-height: 20px;
            cursor: pointer;
            img {
              margin-left: 5px;
              width: 10px;
            }
          }
        }
      }
      .shisanwu-body {
        display: flex;
        padding: 20px 0 20px 24px;
        background-color: #fff;
        .body-left {
          flex: 0 0 748px;
          height: 426px;
          position: relative;
          overflow: hidden;
        }
        .body-right {
          flex: 1;
          border: 1px solid rgba(0, 0, 0, 0.1);
          margin: 0 24px;
          .body-right-title {
            display: block;
            font-size: 18px;
            font-weight: bold;
            color: #000000;
            line-height: 25px;
            padding: 12px 18px;
            border-bottom: 1px solid rgba(0, 0, 0, 0.1);
          }
          .body-right-list {
            li {
              display: flex;
              margin: 12px 24px;
              cursor: pointer;
              .li-icon {
                border-radius: 4px 0px 0px 4px;
                height: 60px;
                width: 60px;
                text-align: center;
                line-height: 60px;
                img {
                  height: 48px;
                  width: 48px;
                }
              }
              .li-span {
                line-height: 60px;
                color: rgba(0, 0, 0, 0.65);
                font-size: 18px;
                background-color: #EAEEF4;
                flex: 1;
                padding-left: 24px;
              }
            }
          }
        }
      }
    }
  }

  .middle-image-container {
    p {
      margin: 0;
      &.img {
        margin-bottom: 24px;
        width: 100%;
        height: 300px;
        overflow: hidden;
        position: relative;
        label{
          position: absolute;
          top:235px;
          left:70px;
          width: 80px;
          text-align: center;
          font-size: 18px;
          color: #FFFFFF;
          line-height: 25px;
          font-weight: 500;
          cursor: pointer;
        }
      }
    }
  }

  .important-news-container {
    padding-bottom: 30px;
    .important-news {
      display: flex;
      .left-content-function {
        flex: 0 0 840px;
        margin-right: 40px;
      }
      .right-content-function {
        flex: 1;
      }
      .left-content-function,
      .right-content-function {
        .tab-nav {
          border-top: 2px solid @color-base;
          background-color: rgba(246, 247, 251, 1);
          position: relative;
          z-index: 1;
          ul {
            display: flex;
            list-style: none;
            li {
              cursor: pointer;
              height: 56px;
              line-height: 56px;
              padding: 0 16px;
              transition: all .3s;
              font-size: 16px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: bold;
              color: #2E5C9A;
              &:hover {
                background-color: @color-base;
                color: #ffffff;
              }
              &.active {
                background-color: @color-base;
                color: #ffffff;
              }
            }
          }
        }
        .tab-content {
          background-color: #ffffff;
          border: 1px solid rgba(0, 0, 0, .1);
          padding: 0 20px;
          position: relative;
          flex: 1;
          overflow: hidden;
          ul {
            li:before{
              content: "\2022";     //圆点
              color: rgba(46, 92, 154, 1);       //颜色
              font-size: 16px;
              padding-right: 8px;         //大小
            }
            li {
              font-size: 16px;
              font-weight: 400;
              color: rgba(0, 0, 0, 0.85);
              border-bottom: 1px solid #eee;
              cursor: pointer;
              height: 60px;
              line-height: 60px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              padding-right: 30px;
              position: relative;
              a {
                color: rgba(0, 0, 0, 0.85);
              }
              &:last-child {
                border-bottom: 0;
              }
              &:hover {
                color: @color-base;
              }
              .right-time {
                position: absolute;
                right: 0;
                top: 0;
                color: rgba(143, 143, 143, 1);
                font-size: 14px;
              }
            }
          }
          .tab-content-inner {
            .text {
              display: block;
              text-indent: 28px;
              li {
                border-bottom: 0 none;
                cursor: text;
                line-height: 20px;
                height: 20px;
                &:hover {
                  color: inherit;
                }
              }
            }
          }
        }
      }
    }
  }

  .research-highlight-container {
    padding-top: 30px;
    padding-bottom: 60px;
    background-color: #f6f7fb;
    .research-highlight {
      display: flex;
      .left-content-function {
        flex: 0 0 840px;
        margin-right: 40px;
      }
      .right-content-function {
        flex: 1;
      }
      .left-content-function,
      .right-content-function {
        .tab-nav {
          border-top: 2px solid #DC2D29;
          background-color: rgba(246, 247, 251, 1);
          position: relative;
          z-index: 1;
          ul {
            display: flex;
            list-style: none;
            li {
              cursor: pointer;
              height: 56px;
              line-height: 56px;
              padding: 0 16px;
              transition: all .3s;
              font-size: 16px;
              font-weight: bold;
              color: #DC2D29;
              &:hover {
                background-color: #DC2D29;
                color: #ffffff;
              }
              &.active {
                background-color: #DC2D29;
                color: #ffffff;
              }
            }
          }
        }
        .tab-content {
          background-color: #ffffff;
          border: 1px solid rgba(0, 0, 0, .1);
          padding: 0 20px;
          position: relative;
          overflow: hidden;
          ul {
            li:before{
              content: "\2022";     //圆点
              color: #000000;       //颜色
              font-size: 16px;
              padding-right: 8px;         //大小
            }
            li {
              font-size: 16px;
              font-weight: 400;
              color: rgba(0, 0, 0, 0.85);
              border-bottom: 1px solid #eee;
              cursor: pointer;
              height: 60px;
              line-height: 60px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              padding-right: 30px;
              position: relative;
              a {
                color: rgba(0, 0, 0, 0.85);
              }
              &:last-child {
                border-bottom: 0;
              }
              &:hover a {
                color: #AB110F;
              }
              .right-time {
                position: absolute;
                right: 0;
                top: 0;
                color: rgba(143, 143, 143, 1);
                font-size: 14px;
              }
            }
          }
          .tab-content-inner {
            .text {
              display: block;
              text-indent: 28px;
              li {
                border-bottom: 0 none;
                cursor: text;
                line-height: 20px;
                height: 20px;
                &:hover {
                  color: inherit;
                }
              }
            }
          }
        }
        .organization-list {
          padding-top: 18px;
          .item {
            margin-bottom: 15px;
            width: 400px;
            height: 60px;
            border-radius: 6px;
            line-height: 60px;
            text-align: center;
            text-decoration: none;
            font-size: 22px;
            font-weight: bold;
            color: #fff;
            letter-spacing: 2px;
            text-shadow: 1px 1px 0px #2E5C9A;
            cursor: pointer;
            &:nth-child(1) {
              background-color: rgba(125, 191, 237, 1);
            }
            &:nth-child(2) {
              background-color: rgba(126, 159, 217, 1);
            }
            &:nth-child(3) {
              background-color: rgba(124, 196, 253, 1);
            }
            &:nth-child(4) {
              background-color: rgba(109, 180, 205, 1);
            }
            &:nth-child(5) {
              margin-bottom: 0;
              background-color: #6DD6EC;
            }
          }
        }
      }
    }
  }

  .outcome-container {
    padding: 30px 0;
    background-color: #ffffff;
    .outcome {
      .outcome-header {
        display: flex;
        justify-content: space-between;
        padding: 0 0 20px 0;
        span {
          border-bottom: 2px solid rgba(46, 92, 154, 1);
          font-family: PingFangSC-Medium, PingFang SC;
          font-size: 24px;
          font-weight: bold;
          color: #000;
          line-height: 33px;
        }
      }
      .outcome-body {
        position: relative;
        padding: 20px 48px;
        background-color: #fff;
        .outcome-body-scroll {
          overflow: hidden;
          ul {
            margin-bottom: 20px;
            height: 200px;
            overflow: hidden;
            li {
              position: relative;
              float: left;
              width: 280px;
              height: 200px;
              overflow: hidden;
              margin: 0 8px;
              a {
                display: block;
                width: 100%;
                height: 100%;
              }
              img {
                width: 100%;
                max-height: 100%;
              }
              span {
                position: absolute;
                left: 0;
                bottom: 0;
                z-index: 1;
                width: 100%;
                height: 40px;
                line-height: 40px;
                text-align: center;
                font-size: 16px;
                color: #fff;
                background-color: rgba(46, 92, 154, 1);
              }
            }
          }
        }
        .content {
          display: flex;
          .content-item {
            flex: 1;
            .title {
              height: 16px;
              padding-left: 8px;
              font-size: 16px;
              font-weight: bold;
              color: rgba(0, 0, 0, 0.85);
              line-height: 16px;
              border-left: 6px solid rgba(212, 59, 54, 1);
            }
            .text {
              width: 473px;
              font-size: 14px;
              color: rgba(0, 0, 0, 0.65);
              line-height: 20px;
              text-indent: 2em;
            }
          }
        }
        .prev-icon {
          position: absolute;
          top: 80px;
          left: 0;
          z-index: 1;
          width: 30px;
          height: 60px;
          line-height: 60px;
          text-align: center;
          background-color: rgba(46, 92, 154, 1);
          cursor: pointer;
          img {
            width: 20px;
          }
          &.disabled {
            background-color: rgba(46, 92, 154, .1);
          }
        }
        .next-icon {
          position: absolute;
          top: 80px;
          right: 0;
          z-index: 1;
          width: 30px;
          height: 60px;
          line-height: 60px;
          text-align: center;
          background-color: rgba(46, 92, 154, 1);
          cursor: pointer;
          img {
            width: 20px;
          }
          &.disabled {
            background-color: rgba(46, 92, 154, .1);
          }
        }
      }
    }
  }

  .special-container {
    padding-top: 30px;
    padding-bottom: 30px;
    background-color: #fff;
    .special {
      .special-header {
        display: flex;
        justify-content: space-between;
        padding: 0 0 20px 0;
        span {
          border-bottom: 2px solid rgba(46, 92, 154, 1);
          font-family: PingFangSC-Medium, PingFang SC;
          font-size: 24px;
          font-weight: bold;
          color: #000;
          line-height: 33px;
        }
      }
      .special-body {
        position: relative;
        width: 100%;
        background-color: #fff;
        ul {
          display: flex;
          justify-content: space-between;
          margin-bottom: 13px;
          width: 100%;
          &:last-child {
            margin-bottom: 0;
          }
          li {
            position: relative;
            flex: 0 0 400px;
            height: 100px;
            img {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
    }
  }

  .link-container {
    width: 100%;
    height: 140px;
    padding: 28px 0;
    background-color: #F7F8FB;
    .link {
      display: flex;
      .link-left {
        flex: 0 0 84px;
        .img-cont {
          position: relative;
          margin-right: 33px;
          width: 84px;
          img {
            width: 100%;
          }
          .text {
            position: absolute;
            top: 4px;
            left: 12px;
            z-index: 1;
            span {
              display: block;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: bold;
              color: #FEA500;
              font-size: 22px;
              letter-spacing: 6px;
              text-shadow: 1px 1px 2px #FFFFFF;
              line-height: 34px;
            }
          }
        }
      }
      .link-list {
        display: flex;
        li {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-right: 32px;
          cursor: pointer;
          .text {
            margin-right: 6px;
            font-size: 16px;
            color: rgba(0, 0, 0, 0.85);
          }
          img {
            width: 13px;
          }
        }
      }
    }
  }

  .body-container {
    width: 100%;

    .body-content {

      .function-text {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .texts-left {
          font-size: 24px;
          font-weight: bold;
          color: #000000;
          line-height: 33px;
          border-bottom: 2px solid #DC2D29;
        }
        .texts-right {
          cursor: pointer;
          font-size: 14px;
          font-weight: 400;
          color: #8F8F8F;
          line-height: 20px;
          img {
            margin-left: 6px;
            width: 10px;
          }
        }
      }

      .carousel-show {
        overflow: hidden;
        .title {
          text-align: center;
          font-size: 24px;
          font-weight: bold;
          margin-bottom: 12px;
        }
        .content {
          font-size: 20px;
          line-height: 32px;
          height: 70px;
          text-indent: 2em;
        }
        .carousel-overall {
          .outcome-header {
            padding-top: 30px;
            padding-bottom: 20px;

            .title {
              height: 42px;
              font-size: 30px;
              font-family: PingFangSC-Semibold, PingFang SC;
              font-weight: 600;
              color: #000000;
              line-height: 42px;
              margin: 0 auto;
              text-align: center;
            }

            .sub-title {
              text-align: center;
              margin: 0 auto;
              height: 25px;
              font-size: 18px;
              font-family: PingFangSC-Semibold, PingFang SC;
              font-weight: 600;
              color: #D0D0D0;
              line-height: 25px;
              margin-top: 4px;
            }

            .line {
              margin: 0 auto;
              width: 61px;
              height: 3px;
              background: #E12422;
              margin-top: 8px;
            }
          }
          .card {
            display: flex;
            justify-content: space-between;
            height: 268px;
            .left {
              width: 30%;
              height: 100%;
              position: relative;
              img {
                width: 100%;
                height: 268px;
              }
              div:nth-of-type(1){
                position: absolute;
                top: 24px;
                left: 24px;
                height: 33px;
                font-size: 24px;
                font-weight: 600;
                color: #FFFFFF;
                line-height: 33px;
              }
              div:nth-of-type(2){
                position: absolute;
                top: 61px;
                left: 24px;
                height: 24px;
                font-size: 20px;
                color: #FFFFFF;
                line-height: 24px;
              }
            }
            .right {
              width: 68%;
              height: 100%;
              display: flex;
              justify-content: space-between;
              .r-left,.r-right {
                width: 48.5%;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                .top {
                  position: relative;
                  img {
                    width: 100%;
                    height: 114px;
                  }
                  div:nth-of-type(1){
                    position: absolute;
                    top: 24px;
                    left: 24px;
                    height: 33px;
                    font-size: 24px;
                    font-weight: 600;
                    color: #FFFFFF;
                    line-height: 33px;
                  }
                  div:nth-of-type(2){
                    position: absolute;
                    top: 61px;
                    left: 24px;
                    height: 24px;
                    font-size: 20px;
                    color: #FFFFFF;
                    line-height: 24px;
                  }
                }
              }
              .r-right {
                width: 48.5%;
              }
            }
          }
          .data-icon {
            display: flex;
            justify-content: space-between;
            width: @body-width;
            margin-top: 20px;

            .icon-each {
              display: inline-block;
              width: 275px;
              height: 180px;
              padding-top: 50px;
              padding-left: 20px;
              padding-right: 20px;
              position: relative;
              text-align: center;
              z-index: 1;
              img {
                z-index: -1;
                position: absolute;
                left: 0;
                top: 0;
                border-radius: 4px;
                max-width: 100%;
              }
              .each-word {
                font-weight: bold;
                margin-bottom: 10px;
                font-size: 28px;
                color: #333;
                letter-spacing: 0;
                line-height: 24px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              }
              .examine {
                cursor: pointer;
                position: absolute;
                bottom: 40px;
                left: 0;
                font-size: 18px;
                width: 100%;
              }
            }
          }
          .function-icon {
            width: @body-width;
            display: flex;
            justify-content: space-between;

            .icon-each {
              position: relative;
              display: inline-block;
              width: 280px;
              height: 200px;
              text-align: center;
              cursor: pointer;
              background: rgba(@color-base, .5);
              &.none {
                visibility: hidden;
              }
              img {
                z-index: 1;
                position: absolute;
                left: 0;
                width: 100%;
                height: 100%;
                border-radius: 4px;
              }

              .each-word {
                z-index: 2;
                display: block;
                text-align: center;
                font-size: 24px;
                font-weight: 500;
                color: #ffffff;
                position: absolute;
                top: 80px;
                left: 40px;
                width: 200px;
              }

              .examine {
                z-index: 2;
                width: 120px;
                height: 34px;
                line-height: 34px;
                border: 1px solid rgba(0, 0, 0, 0.1);
                background: @color-base;
                font-size: 12px;
                color: #ffffff;
                position: absolute;
                left: 80px;
                top: 110px;
                display: none;
              }
            }

            .icon-each:hover img {
              opacity: 0.45;
            }

            .icon-each:hover .examine {
              display: block;
            }

            .icon-each:hover .each-word {
              top: 60px;
            }
          }
          .link-icon {
            display: inline-block;
            width: 22%;
            position: relative;
            a {
              background-color: #ffffff;
              border: 1px solid rgba(0, 0, 0, .1);
              border-radius: 4px;
              display: block;
              text-align: center;
              position: relative;
              z-index: 1;
              img {
                margin: 30px 10px;
              }
              &:hover {
                box-shadow: 2px 2px 4px @color-base;
              }
            }
            span {
              display: block;
              text-align: center;
              margin-top: 10px;
              font-size: 16px;
              color: #999;
              font-weight: bold;
            }
            &:after {
              position: absolute;
              content: "";
              bottom: 48px;
              right: 10px;
              left: auto;
              width: 50%;
              top: 50%;
              max-width: 300px;
              background: #777;
              box-shadow: 0 15px 10px #777;
              transform: rotate(3deg);
            }
          }
          .function-box {
            display: flex;
            float: left;
            &.column {
              flex-direction: column;
            }
            p {
              margin: 0;
              &.img {
                margin-bottom: 24px;
                width: 100%;
                height: 300px;
                overflow: hidden;
              }
              &.h4 {
                margin-bottom: 12px;
                font-size: 16px;
                font-weight: bold;
                color: #000000;
                line-height: 22px;
              }
              &.content {
                margin-bottom: 8px;
                font-size: 14px;
                font-weight: 400;
                color: rgba(0, 0, 0, 0.65);
                line-height: 20px;
                word-break: break-all;
              }
              &.small {
                cursor: pointer;
                text-decoration: underline;
                font-size: 14px;
                font-weight: bold;
                color: #FEA500;
                line-height: 20px;
              }
            }
          }
        }
      }
      .content-function-split {
        display: flex;
      }
      .right-content-function,
      .left-content-function {
        .carousel-overall {
          display: flex;
          margin-top: 20px;
          &.column {
            background-color: transparent;
            flex-direction: column;
            position: relative;
          }
        }
      }
      .left-picture {
        margin-right: 20px;
        max-width: 45%;
        overflow: hidden;
        width: 372px;
        img {
          transition: transform 12s cubic-bezier(.23,1,.32,1);
          &:hover {
            transform: scale(1.1);
          }
        }
      }
      .right-content {
        flex: 1;
        position: relative;
        display: flex;
        flex-direction: column;
        ul {
          li:before{
            content: "\2022";     //圆点
            color: @color-base;       //颜色
            font-size: 20px;
            padding-right: 8px;         //大小
          }
          li {
            cursor: pointer;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            line-height: 40px;
            border-bottom: 1px solid #eee;
          }
          li:hover{
            color: @color-base
          }
        }
        .content-discrete {
          padding-right: 20px;
          .oper-btn {
            bottom: 10px;
            position: absolute;
            right: 40px;
            height: 30px;
            line-height: 30px;
            font-size: 14px;
            width: 80px;
            text-align: center;
          }
        }
      }
    }
  }

  .hot-service {
    background-color: #F6F7FB;
    padding-top: 60px;
    padding-bottom: 60px;
    .floor-title {
      font-size: 30px;
      font-weight: bold;
      color: #333333;
      text-align: center;
      padding: 0;
      line-height: 30px;
      width: 1026px;
      margin: auto;
    }
    .main-line {
      margin: 12px auto 24px;
      width: 60px;
      height: 3px;
      background: #DC2D29;
    }
    .floor-sub-title {
      font-size: 16px;
      color: #878787;
      opacity: 0.87;
      text-align: center;
      margin: 17px auto 0;
      width: 1042px;
      line-height: 30px;
    }
    .hot-service-list {
      height: 500px;
      position: relative;
      display: flex;
      padding: 0 113px;
      justify-content: space-between;
      margin-top: 47px;
    }
    .hot-service-list .hot-service-item {
      width: 64px;
    }
    .hot-service-list .hot-service-item .hot-service-title {
      cursor: pointer;
      position: relative;
      height: 83px;
      display: block;
    }
    .hot-service-list .hot-service-item .service-icon {
      position: absolute;
      top: 0;
      left: 17px;
    }
    .hot-service-list .hot-service-item .active-icon {
      display: none;
    }
    .hot-service-list .hot-service-item .active-down-icon {
      display: none;
      position: absolute;
      bottom: 0;
      left: 24px;
    }
    .hot-service-list .hot-service-item .title-text {
      position: relative;
      left: 0;
      top: 46px;
      font-size: 16px;
      font-weight: bold;
      color: #333333;
      line-height: 16px;
      text-align: center;
    }
    .hot-service-list .hot-service-item.is-active .active-icon,
    .hot-service-list .hot-service-item.no-list:hover .active-icon,
    .hot-service-list .hot-service-item.is-active .active-down-icon,
    .hot-service-list .hot-service-item.no-list:hover .active-down-icon {
      display: block;
    }
    .hot-service-list .hot-service-item.is-active .normal-icon,
    .hot-service-list .hot-service-item.no-list:hover .normal-icon {
      display: none;
    }
    .hot-service-list .hot-service-item.is-active .title-text,
    .hot-service-list .hot-service-item.no-list:hover .title-text {
      color: #AB110F;
    }
    .hot-service-list .hot-service-item.is-active .hot-service-content {
      display: block;
    }
    .hot-service-list .hot-service-content {
      position: absolute;
      top: 100px;
      left: 0;
      width: 1226px;
      height: 400px;
      padding: 39px 47px 0 334px;
      display: none;
    }
    .hot-service-list .hot-service-content .hot-service-top {
      border-bottom: 2px solid #D4D4D4;
      position: relative;
      padding-left: 18px;
      padding-bottom: 14px;
      font-size: 16px;
      font-weight: bold;
      color: #333333;
      line-height: 23px;
    }
    .hot-service-list .hot-service-content .hot-service-top img {
      vertical-align: middle;
      margin-left: 62px;
    }
    .hot-service-list .hot-service-content .hot-service-top a {
      font-size: 14px;
      color: #878787;
      line-height: 23px;
      float: right;
    }
    .hot-service-list .hot-service-content .hot-service-top:after {
      content: "";
      position: absolute;
      bottom: -2px;
      left: 0;
      width: 167px;
      height: 2px;
      background: #AB110F;
    }
    .hot-service-list .hot-service-content .sub-list-content {
      margin-top: 33px;
      display: flex;
    }
    .hot-service-list .hot-service-content .sub-list {
      width: 600px;
      margin-left: 60px;
    }
    .hot-service-list .hot-service-content .sub-list li {
      padding-left: 21px;
      font-size: 15px;
      line-height: 15px;
      position: relative;
      margin-bottom: 23px;
    }
    .hot-service-list .hot-service-content .sub-list li a {
      cursor: pointer;
      color: #333333;
    }
    .hot-service-list .hot-service-content .sub-list li:hover a {
      color: #AB110F;
      text-decoration: underline;
    }
    .hot-service-list .hot-service-content .sub-list li:before {
      content: "";
      position: absolute;
      width: 5px;
      height: 5px;
      left: 0;
      top: 5px;
      background: #000000;
    }
  }
}
</style>
<style lang="less">
.navbar-header.dashboard-header{
  .first-br-box {
    width: 100%;
    height: 120px;
    border: 1px solid #DC2D29 !important;
    background: linear-gradient(180deg, #AB110F 0%, #DC2D29 100%) !important;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
  }
  .upper-link {
    .container {
      li {
        color: #DC2D29 !important;
        &.active {
          background-color: #DC2D29 !important;
          .text {
            &:hover {
              color: #FFFFFF !important;
            }
          }
        }
        .text {
          &:hover {
            color: #AB110F !important;
          }
        }
      }
    }
  }
}
.navbar-footer.dashboard-footer {
  background-color: #AB110F !important;
}
</style>



// WEBPACK FOOTER //
// src/layout/home/home.vue